module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/cover#cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cover")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/titlepage#tit",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/dedication#ded",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/epigraph#epi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epigraph")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-top-1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/boundlesssea#fm"
    }
  }, [_vm._v("The Boundless Sea")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-pt"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part1#pt1"
    }
  }, [_vm._v("I. Fusion Torch Ship "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Australia")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#ch1"
    }
  }, [_vm._v("Ceres Orbit: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Chrysalis II")]), _vm._v(" Habitat")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter2#ch2"
    }
  }, [_vm._v("Fusion Torch Ship "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Australia")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter3#ch3"
    }
  }, [_vm._v("Captain’s Quarters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter4#ch4"
    }
  }, [_vm._v("Leviathan")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter5#ch5"
    }
  }, [_vm._v("Infirmary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter6#ch6"
    }
  }, [_vm._v("Ship’s Passageway")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter7#ch7"
    }
  }, [_vm._v("Main Lounge")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter8#ch8"
    }
  }, [_vm._v("Jupiter Orbit: Research Station "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Thomas Gold")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter9#ch9"
    }
  }, [_vm._v("Fusion Torch Ship "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Australia")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter10#ch10"
    }
  }, [_vm._v("Main Lounge")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Passenger Quarters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Katherine Westfall’s Suite")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Electronics Workshop")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Infirmary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dolphin Tank")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Metamorphosis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Contact")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Main Lounge")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Infirmary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter20#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Leviathan")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter21#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Observation Blister")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter22#ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dorn’s Transformation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter23#ch23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Andy Corvus’s Stateroom")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter24#ch24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Infirmary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter25#ch25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Katherine Westfall’s Suite")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter26#ch26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dolphin Tank")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter27#ch27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Infirmary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter28#ch28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Infirmary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-top"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter29#ch29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Leviathan")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-pt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part2#pt2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II. Jupiter Orbit: Research Station "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Gold")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter30#ch30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Recovery")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter31#ch31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Station "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Gold")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter32#ch32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Intellectual Cousins")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter33#ch33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Katherine Westfall’s Quarters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter34#ch34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grant Archer’s Office")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter35#ch35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dinner")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter36#ch36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plans")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter37#ch37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Control Center")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter38#ch38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Research Vessel "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Faraday")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter39#ch39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ultrahyperbaric Chamber")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter40#ch40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dolphin Tank")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter41#ch41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grant Archer’s Office")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter42#ch42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Katherine Westfall’s Quarters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter43#ch43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Launch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter44#ch44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Perfluorocarbon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter45#ch45",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Faraday")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter46#ch46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Galley")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter47#ch47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Countermove")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter48#ch48",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Faraday")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter49#ch49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Observation Deck")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter50#ch50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Attack")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter51#ch51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Control Center")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter52#ch52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conference Room")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter53#ch53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fluid Dynamics Laboratory")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter54#ch54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Immersion Center")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter55#ch55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mission Control Center")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-top"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter56#ch56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Leviathan")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-pt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part3#pt3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III. Preparations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter57#ch57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Immersion Center")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter58#ch58",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Faraday")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter59#ch59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Main Conference Room")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter60#ch60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grant Archer’s Office")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter61#ch61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Clinic")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter62#ch62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Main Galley")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter63#ch63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nanotech Laboratory")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter64#ch64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sacrifice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter65#ch65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nanotech Laboratory")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter66#ch66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mission Control Center")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter67#ch67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dorn’s Quarters  ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter68#ch68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rodney Devlin")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter69#ch69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Observation Deck")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter70#ch70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dolphin Tank")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter71#ch71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Leviathan")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter72#ch72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grant Archer’s Office")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter73#ch73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kitchen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter74#ch74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nanotechnology Laboratory")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-top"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter75#ch75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Launch Party")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-pt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part4#pt4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV. The Mission")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter76#ch76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Immersion Capsule")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter77#ch77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Launch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter78#ch78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Leviathan")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter79#ch79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Katherine Westfall’s Quarters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter80#ch80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Through the Atmosphere")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter81#ch81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Into the Ocean")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter82#ch82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Searching")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter83#ch83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Research Station "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Gold")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter84#ch84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Leviathan")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter85#ch85",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Faraday")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter86#ch86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dissociation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter87#ch87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Charge of the Light Brigade")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter88#ch88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Contact")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter89#ch89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Communication")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter90#ch90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cats and Mouse")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter91#ch91",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Faraday")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter92#ch92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Images")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter93#ch93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grant Archer’s Office")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter94#ch94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deeper")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter95#ch95",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grant Archer’s Office")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter96#ch96",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Faraday")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter97#ch97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grant Archer’s Office")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter98#ch98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Leviathan")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter99#ch99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Katherine Westfall’s Suite")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter100#ch100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Decision")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter101#ch101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Miscommunication")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter102#ch102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conference Room")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter103#ch103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wild Ride")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter104#ch104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Observation Blister")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter105#ch105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Kin")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter106#ch106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Elders")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter107#ch107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Katherine Westfall")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter108#ch108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Symmetry")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter109#ch109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Decisions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter110#ch110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Trouble")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter111#ch111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Questions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter112#ch112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Responsibilities")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter113#ch113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Escape")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-top-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter114#ch114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Departure")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/epilogue#epil",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/decompression#bm1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Decompression")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/debriefing#bm2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Debriefing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/farewell#bm3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Farewell")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/teaser#tea",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excerpt: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Earth")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/adcard#adc",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tor books by Ben Bova")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyright#copy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ab8948c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 69
// module chunks = 0